import { useState } from 'react'
import { useAuthContext } from './useAuthContext'
import { useStateContext } from '../../../context/StateContext'

export const useSignup = (AuthContext) => {

  const [error, setError] = useState(null)
  const [result, setResult] = useState(null)
  const [isLoading, setIsLoading] = useState(null)
  const { dispatch } = useAuthContext(AuthContext)
  //const {apiUrl} = useStateContext()
  const apiUrl = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:4000'
  : process.env.REACT_APP_BACKEND_URL 

  const signup = async ({email, password, companyId, mindProId, userType, allowNoPassword, login, language}) => {
    setIsLoading(true)
    setError(null)

    const response = await fetch(`${apiUrl}/user/signup`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ email, password, companyId, mindProId, userType, allowNoPassword, language})
    })
    const json = await response.json()

    if (!response.ok) {
      setIsLoading(false)
      setError(json.error)
    }
    if (response.ok) {
      if (login) {
        // save the user to local storage
        localStorage.setItem('user', JSON.stringify(json))

        // update the auth context
        dispatch({type: 'LOGIN', payload: json})
      }


      // update loading state
      setResult({success: true})
      setIsLoading(false)
    }
  }

  return { signup, result, isLoading, error }
}